import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=6f7fc97a&scoped=true"
import script from "./EmailConfirm.vue?vue&type=script&lang=js"
export * from "./EmailConfirm.vue?vue&type=script&lang=js"
import style0 from "./EmailConfirm.vue?vue&type=style&index=0&id=6f7fc97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7fc97a",
  null
  
)

export default component.exports